import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import './MapTfvLayerLegend.css';
import { CloseCircleOutlined } from '@ant-design/icons';

export class TfvLayerLabelTitle extends PureComponent<{ onClose: () => void }> {
    render() {
        return (
            <Flex>
                <Flex style={{ fontWeight: 'bold', justifyContent: 'center' }}>LEGEND</Flex>
                <Flex grow={false} style={{ alignSelf: 'flex-end' }}>
                    <CloseCircleOutlined style={{ fontSize: '1.5em' }} onClick={this.props.onClose} />
                </Flex>
            </Flex>
        );
    }
}

export class TfvLayerLabelContent extends PureComponent {
    render() {
        return (
            <div className="tfv-legend">
                <table className="center fixDimensions border">
                    <tbody>
                        <tr>
                            <td style={{ width: '6em', textAlign: 'right' }}>Classification</td>
                            <td>Monit</td>
                            <td>Non Monit</td>
                            <td>Future</td>
                            <td>Selected</td>
                        </tr>
                        <tr>
                            <td style={{ width: '6em', textAlign: 'right' }}>High</td>
                            <td className="orange" />
                            <td className="orange notMonit" />
                            <td className="futureOrange" />
                            <td className="orange selected" />
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>Overload</td>
                            <td className="red" />
                            <td className="red notMonit" />
                            <td className="futureRed" />
                            <td className="red selected" />
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}
